var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 27.5H43L31 20.5L27.5 16.5H42L49 27.5Z",
    fill: "#B5D0F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7737 3.94792C17.182 3.45988 17.9362 3.47218 18.3283 3.97326L32.7352 22.3837C33.2489 23.0401 32.7812 24 31.9477 24H2.14025C1.29154 24 0.828677 23.0094 1.37323 22.3584L16.7737 3.94792Z",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.5H39.9415C41.2333 16.5 42.4456 17.1239 43.1965 18.175L48.9353 26.2094C49.1717 26.5403 48.9351 27 48.5284 27H46C45.4477 27 45 27.4477 45 28V39.5",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H31V39C31 39.5523 30.5523 40 30 40H5C4.44771 40 4 39.5523 4 39V24Z",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 40,
    width: 48,
    height: 6,
    rx: 1,
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 27H31.5",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31.5C19 29.567 20.567 28 22.5 28V28C24.433 28 26 29.567 26 31.5V40H19V31.5Z",
    fill: "#B5D0F9",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 13.3431 15.3431 12 17 12V12C18.6569 12 20 13.3431 20 15V18H14V15Z",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 31C8.5 29.3431 9.84315 28 11.5 28V28C13.1569 28 14.5 29.3431 14.5 31V34H8.5V31Z",
    stroke: "#476BF0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.f411b22cbadf9b7851fddcd2185548e4.svg";
export { ForwardRef as ReactComponent };